"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpeningGroupContext = exports.OpeningGroupContextProvider = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@mapmaker/core");
const openingUtils_1 = require("./openingUtils");
const OpeningGroupContext = (0, react_1.createContext)({
    outermostVisibleLayer: null,
    imageClipLayerWithoutBuffer: null,
    showOnFullMap: true,
    isMatboardOuterOpening: true,
    scale: 1,
});
function OpeningGroupContextProvider({ opening, openingInput, scale = 1, children, }) {
    const outermostVisibleLayer = (0, react_1.useMemo)(() => {
        return opening.outlined
            ? opening.layout.cut
            : (0, openingUtils_1.getLayerByPriority)(opening, ["inner", "cut"]);
    }, [opening]);
    const imageClipLayerWithoutBuffer = (0, react_1.useMemo)(() => {
        return opening.outlined
            ? opening.layout.print
            : (0, openingUtils_1.getLayerByPriority)(opening, ["cut", "inner"]);
    }, [opening]);
    const showOnFullMap = (0, react_1.useMemo)(() => {
        return true;
    }, [opening]);
    const isMatboardOuterOpening = (0, react_1.useMemo)(() => (0, core_1.isMatboardOuterOpening)(opening), [opening]);
    return (react_1.default.createElement(OpeningGroupContext.Provider, { value: {
            outermostVisibleLayer,
            imageClipLayerWithoutBuffer,
            showOnFullMap,
            isMatboardOuterOpening,
            scale,
        } }, children));
}
exports.OpeningGroupContextProvider = OpeningGroupContextProvider;
function useOpeningGroupContext() {
    return (0, react_1.useContext)(OpeningGroupContext);
}
exports.useOpeningGroupContext = useOpeningGroupContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiT3BlbmluZ0dyb3VwQ29udGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL29wZW5pbmcvT3BlbmluZ0dyb3VwQ29udGV4dC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSwrQ0FLZTtBQUNmLHlDQUt3QjtBQUN4QixpREFBb0Q7QUFlcEQsTUFBTSxtQkFBbUIsR0FBRyxJQUFBLHFCQUFhLEVBQTJCO0lBQ2xFLHFCQUFxQixFQUFFLElBQUk7SUFDM0IsMkJBQTJCLEVBQUUsSUFBSTtJQUNqQyxhQUFhLEVBQUUsSUFBSTtJQUNuQixzQkFBc0IsRUFBRSxJQUFJO0lBQzVCLEtBQUssRUFBRSxDQUFDO0NBQ1QsQ0FBQyxDQUFDO0FBUUgsU0FBZ0IsMkJBQTJCLENBQUMsRUFDMUMsT0FBTyxFQUNQLFlBQVksRUFDWixLQUFLLEdBQUcsQ0FBQyxFQUNULFFBQVEsR0FDNEM7SUFDcEQsTUFBTSxxQkFBcUIsR0FBRyxJQUFBLGVBQU8sRUFBQyxHQUFHLEVBQUU7UUFDekMsT0FBTyxPQUFPLENBQUMsUUFBUTtZQUNyQixDQUFDLENBQUMsT0FBTyxDQUFDLE1BQU0sQ0FBQyxHQUFHO1lBQ3BCLENBQUMsQ0FBQyxJQUFBLGlDQUFrQixFQUFDLE9BQU8sRUFBRSxDQUFDLE9BQU8sRUFBRSxLQUFLLENBQUMsQ0FBQyxDQUFDO0lBQ3BELENBQUMsRUFBRSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7SUFDZCxNQUFNLDJCQUEyQixHQUFHLElBQUEsZUFBTyxFQUFDLEdBQUcsRUFBRTtRQUMvQyxPQUFPLE9BQU8sQ0FBQyxRQUFRO1lBQ3JCLENBQUMsQ0FBQyxPQUFPLENBQUMsTUFBTSxDQUFDLEtBQUs7WUFDdEIsQ0FBQyxDQUFDLElBQUEsaUNBQWtCLEVBQUMsT0FBTyxFQUFFLENBQUMsS0FBSyxFQUFFLE9BQU8sQ0FBQyxDQUFDLENBQUM7SUFDcEQsQ0FBQyxFQUFFLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQztJQUVkLE1BQU0sYUFBYSxHQUFHLElBQUEsZUFBTyxFQUFDLEdBQUcsRUFBRTtRQUNqQyxPQUFPLElBQUksQ0FBQztJQUNkLENBQUMsRUFBRSxDQUFDLE9BQU8sQ0FBQyxDQUFDLENBQUM7SUFFZCxNQUFNLHNCQUFzQixHQUFHLElBQUEsZUFBTyxFQUNwQyxHQUFHLEVBQUUsQ0FBQyxJQUFBLDZCQUEwQixFQUFDLE9BQU8sQ0FBQyxFQUN6QyxDQUFDLE9BQU8sQ0FBQyxDQUNWLENBQUM7SUFFRixPQUFPLENBQ0wsOEJBQUMsbUJBQW1CLENBQUMsUUFBUSxJQUMzQixLQUFLLEVBQUU7WUFDTCxxQkFBcUI7WUFDckIsMkJBQTJCO1lBQzNCLGFBQWE7WUFDYixzQkFBc0I7WUFDdEIsS0FBSztTQUNOLElBRUEsUUFBUSxDQUNvQixDQUNoQyxDQUFDO0FBQ0osQ0FBQztBQXZDRCxrRUF1Q0M7QUFFRCxTQUFnQixzQkFBc0I7SUFDcEMsT0FBTyxJQUFBLGtCQUFVLEVBQTJCLG1CQUFtQixDQUFDLENBQUM7QUFDbkUsQ0FBQztBQUZELHdEQUVDIn0=